export const POD_STATE_LABELS = {
  offline: "Not connected",
  ready: "Ready",
  paused: "On break",
  on_call: "On a call",
  wrap_up: "Wrap-up",
}

export const POD_SESSION_LABELS = {
  active: "Dialing",
  paused: "Paused by admin",
  ending: "Finishing up",
}

export function formatSeconds(totalSeconds) {
  const seconds = Math.max(0, Math.floor(totalSeconds || 0))
  const minutes = Math.floor(seconds / 60)
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`
}

export function secondsSince(isoDate, now = Date.now()) {
  if (!isoDate) return 0
  return (now - new Date(isoDate).getTime()) / 1000
}

export function formatNextBlock(isoDate) {
  if (!isoDate) return "No dialing scheduled."
  const date = new Date(isoDate)
  return `Next dialing block: ${date.toLocaleString(undefined, {
    weekday: "short",
    hour: "numeric",
    minute: "2-digit",
  })}`
}

export function apiErrorMessage(err, fallback) {
  const data = err?.response?.data
  if (!data) return fallback
  if (typeof data.detail === "string") return data.detail
  const first = Object.values(data)[0]
  return Array.isArray(first) ? String(first[0]) : fallback
}

/**
 * "Client — Campaign" when the campaign is not just the client's default one
 * (default campaigns are named after the client).
 */
export function clientAndCampaign(client, campaign) {
  return campaign && campaign !== client ? `${client} — ${campaign}` : client
}
